const Fetcher = require('od-modules/utils/fetcher');
const SEARCH = require('./search_constants');
const odigeojsCommunications = require('./odigeojs_comunication');
const logger = require('od-modules/utils/logger');


const getGenericValuesWithUrlParams = (urlParams, paramsParser) => {
    let search = Odigeo._.clone(SEARCH.DEFAULT);
    let segmentKeys = [];
    let externalSelectionRequest = {};

    if (odigeojsCommunications.getOdigeoABValue('isOfferChildrenAgeDesktop')) {
        search = Odigeo._.extend(search, SEARCH.AGE_SELECTOR);
    }
    search.type = SEARCH.TYPES[urlParams.type];
    Object.keys(Odigeo._.omit(urlParams, 'type')).forEach((paramName) => {
        const paramValue = urlParams[paramName];
        const formatterFunction = SEARCH.PARAMS_FORMATTER_FUNCTIONS[paramName];
        const segmentKeyMatchResult = SEARCH.MAPI_PARAMS.regex.exec(paramName);
        if (Odigeo._.isFunction(formatterFunction) && formatterFunction(paramValue) !== undefined) {
            search[paramsParser[paramName]] = formatterFunction(paramValue);
        }
        if (!Odigeo._.isNull(segmentKeyMatchResult)) {
            segmentKeys[segmentKeyMatchResult[2]] = paramValue;
        }
    });

    if (Odigeo._.has(urlParams, 'fareItineraryKey')) {
        externalSelectionRequest.fareItineraryKey = urlParams.fareItineraryKey;
    }
    if (!Odigeo._.isEmpty(segmentKeys)) {
        externalSelectionRequest.segmentKeys = segmentKeys;
    }

    return {search, externalSelectionRequest};
};

const getSearchSegmentsWithUrlParams = (urlParams, searchType) => {
    let searchSegments = [];
    const formatterConfiguration = SEARCH.SEGMENTS_FORMATTER_FUNCTIONS[searchType];
    if (formatterConfiguration) {
        Object.keys(urlParams).forEach((paramName) => {
            const paramValue = urlParams[paramName];
            const matchResult = formatterConfiguration.regex.exec(paramName);
            if (!Odigeo._.isNull(matchResult)) {
                const matchedName = matchResult[1];
                if (Odigeo._.isFunction(formatterConfiguration.cases[matchedName])) {
                    searchSegments = formatterConfiguration.cases[matchedName](paramValue, searchSegments, matchResult);
                } else if (Odigeo._.isFunction(formatterConfiguration.cases.defaultParser)) {
                    searchSegments = formatterConfiguration.cases.defaultParser(paramValue, searchSegments, matchResult);
                }
            }
        });
    }
    return searchSegments;
};

const getMapiParams = (urlParams) => {
    let externalSelectionRequest = {};
    if (!Odigeo._.isUndefined(urlParams.segmentKey0)) {
        let segmentKeys = [];
        externalSelectionRequest.searchId = urlParams.searchId;
        externalSelectionRequest.fareItineraryKey = urlParams.fareItineraryKey;

        Odigeo._.each(urlParams, function(val, key) {
            const result = SEARCH.MAPI_PARAMS.regex.exec(key);
            if (!Odigeo._.isNull(result)) {
                segmentKeys[result[2]] = val;
            }
        });
        Odigeo._.extend(externalSelectionRequest, {segmentKeys});

        setProviderToSessionScope(urlParams.fareItineraryKey);
        setCarriersToSessionScope(segmentKeys);

        if (hasGfsParameters(urlParams)) {
            externalSelectionRequest.displayedPrice = urlParams.DisplayedPrice;
            externalSelectionRequest.displayedCurrency = urlParams.DisplayedPriceCurrency;
        }
    }
    return externalSelectionRequest;
};

const setProviderToSessionScope = (fareItineraryKey) => Odigeo.SessionScope.provider = getProviderFromFareItineraryKey(fareItineraryKey);

const getProviderFromFareItineraryKey = (fareItineraryKey) => {
    const fareItineraryKeyDivided = splitKey(fareItineraryKey);
    const fareItineraryWithoutItineraryPosition = removeItineraryPosition(fareItineraryKeyDivided);
    return fareItineraryWithoutItineraryPosition;
};

const setCarriersToSessionScope = (segmentKeys) => Odigeo.SessionScope.carriers = Array.from(new Set(extractCarrierCodes(segmentKeys))).join();

const extractCarrierCodes = (segmentKeys) => segmentKeys.map((segmentKey) => {
    const segmentKeyDivided = splitKey(segmentKey);
    const segmentKeyWithoutItineraryPosition = removeItineraryPosition(segmentKeyDivided);
    return getAirlineCode(segmentKeyWithoutItineraryPosition);
});

const splitKey = (key) => key.split(',');
const getAirlineCode = (segmentKey) => segmentKey.substr(0, 2);
const removeItineraryPosition = (segmentKey) => segmentKey.slice(1).join();
const hasGfsParameters = (urlParams) => urlParams.DisplayedPrice && urlParams.DisplayedPriceCurrency && urlParams.t && urlParams.sig;

const getWindowSearchString = () => window.location.search.substring(1);

const getQueryParams = () => getMapiParams(odigeojsCommunications.getOdigeoUtilsFunction('decodeParams')(getWindowSearchString()));

const getSearchParamsFromUrl = (urlParams, keyParams) => {
    let {search, externalSelectionRequest} = getGenericValuesWithUrlParams(urlParams, Odigeo._.extend({}, SEARCH.PARAMS_PARSER, keyParams));
    search.externalSelectionRequest = externalSelectionRequest;
    search.searchSegments = getSearchSegmentsWithUrlParams(urlParams, search.type);
    urlParams.trainSearch && Odigeo._.extend(search, getSearchAgeUrlParams(urlParams));
    Odigeo._.extend(search.externalSelectionRequest, getQueryParams());
    return search;
};

const parseHashParams = (hashParameters) => {
    var hash;
    var splitHash = new RegExp(/(?:;|%3B)/gi);
    var separatorHash = '=';
    var separatorPath = '/';

    return Odigeo._.reduce(Odigeo._.compact(_(hashParameters).trimLeft(separatorPath).split(splitHash)), function(memo, params) {
        hash = params.split(separatorHash);
        memo[hash[0]] = hash[1];
        return memo;
    }, {});
};

const flightsSearchParamsParser = (params) => {
    return getSearchParamsFromUrl(parseHashParams(params));
};

const hasCompletedLocations = (orig, dest) => {
    return Odigeo._.isObject(orig) && Odigeo._.isObject(dest) &&
        orig.searchSegments.length === dest.searchSegments.length &&
        Odigeo._.every(orig.searchSegments, function(s, i) {
            var seg = dest.searchSegments[i];
            if (Odigeo._.matches(seg.departure)(s.departure) &&
                Odigeo._.matches(seg.destination)(s.destination)) {
                seg.departure = s.departure;
                seg.destination = s.destination;
                return true;
            } else {
                return false;
            }
        });
};

const isNotMultipleSearchAndNotOriginData = (params) => params.toString().indexOf('type=M') === -1 &&
    params.toString().indexOf('from.') === -1 &&
    params.toString().indexOf('from=') === -1;

const getClosestAirportsParam = () => {
    return new Promise((resolve, reject) => {
        odigeojsCommunications.getOdigeoLocation().get().then((pos) => {
            const geoUrl = odigeojsCommunications.getUrlService('geoServiceUrlFormatter', 'geocomplete') +
                ';latitude=' + pos.coords.latitude +
                ';longitude=' + pos.coords.longitude;

            return Fetcher.get(geoUrl).json();
        }).then((closestAirport) => {
            let value;
            const selected = closestAirport.airports[0] || closestAirport.cities[0] || false;

            if (selected) {
                value = Odigeo._.extend(Odigeo._.pick(selected, [
                    'city',
                    'text',
                    'geoNodeId',
                    'iata',
                    'country',
                    'countryCode',
                    'name',
                    'type',
                ]));
            }
            return `;from=${value.iata};`;
        }).then(resolve, reject);
    });
};

const completeWithGeoInfo = (search) => {
    let iatas = [];
    let geoNodes = [];
    let completed = Odigeo._.clone(search);
    const attributes = ['dateStr', 'time', 'timeWindow'];

    // Extract locations
    const locations = Odigeo._.chain(search.searchSegments)
        .map(Odigeo._.flowRight(Odigeo._.values, Odigeo._.partial(Odigeo._.omit, _, attributes)))
        .flatten()
        .value();

    // Collect queries
    Odigeo._.each(locations, function(loc) {
        if (Odigeo._.has(loc, 'geoNodeId')) {
            geoNodes.push(loc.geoNodeId);
        } else if (Odigeo._.has(loc, 'iata')) {
            iatas.push(loc.iata);
        }
    });

    // Filter queries
    iatas = Odigeo._.uniq(iatas);
    geoNodes = Odigeo._.uniq(geoNodes);

    // Build querystring
    const query = Odigeo._.map(iatas, function(iata) {
        return `iatas=${iata}`;
    }).concat(Odigeo._.map(geoNodes, function(geoNode) {
        return `ids=${geoNode}`;
    })).join(';');

    if (query) {
        return Fetcher.get(`${odigeojsCommunications.getUrlService('geoServiceUrlFormatter', 'locations')};${query}`).json()
            .then(function(geoData) {
                // Fill in the blanks
                completed.searchSegments = Odigeo._.map(search.searchSegments, function(segment) {
                    Odigeo._.each(segment, function(loc, type, segment) {
                        let fullData;

                        if (!Odigeo._.includes(attributes, type)) {
                            if (Odigeo._.includes(iatas, loc.iata)) {
                                fullData = Odigeo._.find(geoData, Odigeo._.matches({'iata': loc.iata}));
                            } else if (Odigeo._.includes(geoNodes, loc.geoNodeId)) {
                                fullData = Odigeo._.find(geoData, Odigeo._.matches({'geoNodeId': parseInt(loc.geoNodeId, 10)}));
                            }

                            if (fullData) {
                                loc = Odigeo._.defaults(loc, fullData);
                            } else {
                                return Promise.reject('WRONG_SEARCH');
                            }
                        }
                        segment[type] = loc;
                    });

                    return segment;
                });

                return completed;
            })
            .catch((error) => {
                return Promise.reject('WRONG_SEARCH');
            });
    } else {
        return Promise.resolve(completed);
    }
};

const composeSearchData = (urlParametersFullFilled, params, parser, page) => {
    // Check if searching from previous page
    let pageStorage = odigeojsCommunications.getOdigeoSessionValue('searchParameters');
    let urlParametersFormatted = null;

    if (!Odigeo._.isNull(pageStorage)) {
        try {
            pageStorage = JSON.parse(pageStorage);
        } catch (error) {
            logger.error(error);
            pageStorage = null;
        }
    }

    if (!Odigeo._.isEmpty(params)) {
        urlParametersFormatted = parser(params);
    }

    if (Odigeo._.isNull(urlParametersFormatted)) {
        if (Odigeo._.isEmpty(pageStorage)) {
            return Promise.reject('NO_SEARCH');
        }
        return Promise.resolve(pageStorage);
    } else if (urlParametersFullFilled && hasCompletedLocations(pageStorage, urlParametersFormatted)) {
        urlParametersFormatted.buyPath = urlParametersFormatted.buyPath || getDirectUrlBuyPath(page);
        return Promise.resolve(urlParametersFormatted);
    } else if (!Odigeo._.isNull(pageStorage) && hasCompletedLocations(pageStorage, urlParametersFormatted)) {
        urlParametersFormatted.buyPath = urlParametersFormatted.buyPath || pageStorage.buyPath;
        return Promise.resolve(urlParametersFormatted);
    } else {
        urlParametersFormatted.buyPath = urlParametersFormatted.buyPath || getDirectUrlBuyPath(page);
        return completeWithGeoInfo(urlParametersFormatted);
    }
};

const isDynpackFlightsResults = (currentPage) => {
    return /^(dpresults|dpresults_flights)$/.test(currentPage);
};

const isAccommodationResults = (currentPage) => {
    return /^(dpresults|dpresults_accommodation)$/.test(currentPage);
};

const getDynpackMobileBuyPath = () => {
    const mobileBuyPath = odigeojsCommunications.getOdigeoSessionValue('mobileBuyPath');
    odigeojsCommunications.removeOdigeoSessionProperty('mobileBuyPath');
    return mobileBuyPath || 'DYNPACK_DIRECT_URL';
};

const getDirectUrlBuyPath = (currentPage) => {
    const directUrlBuyPath = isDynpackFlightsResults(currentPage) || isAccommodationResults(currentPage) ?
        getDynpackMobileBuyPath() : 'FLIGHTS_DIRECT_URL';

    return directUrlBuyPath;
};

const getSearchData = async(params, currentPage, paramsParserFun) => {
    let urlParams = params;
    const searchParamsParser = Odigeo._.isFunction(paramsParserFun) ? paramsParserFun : flightsSearchParamsParser;

    if (!Odigeo._.isEmpty(urlParams) && isNotMultipleSearchAndNotOriginData(urlParams) && (currentPage === 'results' || currentPage === 'flights')) {
        if (navigator && odigeojsCommunications.getFlow() !== 'desktop') {
            try {
                urlParams += await getClosestAirportsParam();

                return composeSearchData(true, urlParams, searchParamsParser, currentPage);
            } catch (error) {
                let urlParamsFormatted;
                if (currentPage === 'flights') {
                    if (!Odigeo._.isEmpty(urlParams)) {
                        urlParamsFormatted = searchParamsParser(urlParams);
                    }
                    urlParamsFormatted.buyPath = getDirectUrlBuyPath(currentPage);
                    try {
                        return completeWithGeoInfo(urlParamsFormatted);
                    } catch (error) {
                        logger.error(error);
                        return error;
                    }
                } else {
                    odigeojsCommunications.getOdigeoUtilsFunction('goToApplicationHome')();
                }
            }
        }
    } else {
        return composeSearchData(false, urlParams, searchParamsParser, currentPage);
    }
};

const searchParamsStringify = (searchParams, keyParams) => {
    // Order of this array affects order of the parameters in the string
    const keyMap = Odigeo._.extend({}, SEARCH.PARAMS_STRINGIFY, keyParams);
    const typeMap = Odigeo._.invert(SEARCH.TYPES);
    const pickedParams = Odigeo._.pick(searchParams, Odigeo._.keys(keyMap));
    const defaultPassengers = searchParams.numAdults === 1 &&
        searchParams.numChildren === 0 &&
        searchParams.numInfants === 0;
    let paramString = Odigeo._.chain(pickedParams)
        .reduce(function(memo, val, key) {
            let data;

            switch (key) {
                case 'searchSegments':
                    return memo + ';' + Odigeo._.chain(val)
                        .map(function(seg, idx) {
                            const fromVal = seg.departure.geoNodeId || seg.departure.iata;
                            let toVal = seg.destination.geoNodeId || seg.destination.iata;
                            let depString = Odigeo._.clone(SEARCH.STRINGIFY_DATES_VALUES.dep);
                            let fromString = Odigeo._.clone(SEARCH.STRINGIFY_DATES_VALUES.from);
                            let toString = Odigeo._.clone(SEARCH.STRINGIFY_DATES_VALUES.to);
                            const searchSegments = [];

                            if (searchParams.type === 'roundTrip' && idx === 1) {
                                searchSegments.push(`${SEARCH.STRINGIFY_DATES_VALUES.ret}=${seg.dateStr}`);
                                const retString = SEARCH.STRINGIFY_DATES_VALUES.ret;
                                if (seg.time) {
                                    searchSegments.push(`${retString}${SEARCH.STRINGIFY_DATES_VALUES.time}=${seg.time}`);
                                }
                                if (seg.timeWindow) {
                                    searchSegments.push(`${retString} ${SEARCH.STRINGIFY_DATES_VALUES.timeWindow}=${seg.timeWindow}`);
                                }
                                return searchSegments;
                            }
                            if (searchParams.type === 'multipleTrip') {
                                depString += String(idx);
                                fromString += String(idx);
                                toString += String(idx);
                            }

                            searchSegments.push(`${depString}=${seg.dateStr}`);
                            searchSegments.push(`${fromString}=${fromVal}`);
                            searchSegments.push(`${toString}=${toVal}`);

                            if (seg.time) {
                                searchSegments.push(`${depString}${SEARCH.STRINGIFY_DATES_VALUES.time}=${seg.time}`);
                            }
                            if (seg.timeWindow) {
                                searchSegments.push(`${depString}${SEARCH.STRINGIFY_DATES_VALUES.timeWindow}=${seg.timeWindow}`);
                            }

                            return searchSegments;
                        })
                        .flatten()
                        .value()
                        .join(';');
                case 'type':
                    data = typeMap[val];
                    break;
                case 'numAdults':
                case 'numChildren':
                case 'numInfants':
                    if (!defaultPassengers && val !== 0) {
                        data = String(val);
                    } else {
                        return memo;
                    }
                    break;
                default:
                    if (val === SEARCH.DEFAULT[key]) {
                        return memo;
                    }
                    data = String(val) || 'false';
                    break;
            }

            return `${memo};${keyMap[key]}=${data}`;
        }, '')
        .tap(encodeURI)
        .value().substring(1);

    if (searchParams.trainSearch === true) {
        const {numAdults = 0, numChildren = 0, numInfants = 0} = searchParams;
        if (Odigeo.SessionScope.trainAgeEnabled) {
            if (numAdults > 0) {
                paramString += `;adultAges=${searchParams.adultAges}`;
            }
            if (numChildren > 0) {
                paramString += `;childrenAges=${searchParams.childrenAges}`;
            }
            if (numInfants > 0) {
                paramString += `;infantAges=${searchParams.infantAges}`;
            }
        } else {
            if (numAdults > 0) {
                paramString += `;adultAges=${Array(numAdults).fill(30).join('-')}`;
            }
            if (numChildren > 0) {
                paramString += `;childrenAges=${Array(numChildren).fill(10).join('-')}`;
            }
            if (numInfants > 0) {
                paramString += `;infantAges=${Array(numInfants).fill(1).join('-')}`;
            }
        }
    }

    return paramString;
};

const getSearchAgeUrlParams = (urlParams) => {
    const ageParams = {};
    const numAdults = parseInt(urlParams.adults, 10) || 1;
    const numChildren = parseInt(urlParams.children, 10) || 0;
    const numInfants = parseInt(urlParams.infants, 10) || 0;
    if (urlParams.adultAges) {
        ageParams.adultAges = urlParams.adultAges;
    } else if ( numAdults > 0) {
        ageParams.adultAges = Array(numAdults).fill(30).join('-');
    }
    if (urlParams.childrenAges) {
        ageParams.childrenAges = urlParams.childrenAges;
    } else if (numChildren > 0) {
        ageParams.childrenAges = Array(numChildren).fill(10).join('-');
    }
    if (urlParams.infantAges) {
        ageParams.infantAges = urlParams.infantAges;
    } else if (numInfants > 0) {
        ageParams.infantAges = Array(numInfants).fill(1).join('-');
    }
    return ageParams;
};

module.exports = {
    getSearchParamsFromUrl,
    getMapiParams,
    getQueryParams,
    getSearchData,
    searchParamsStringify,
    completeWithGeoInfo,
    isDynpackFlightsResults,
    getSearchAgeUrlParams,
    isAccommodationResults,
};
